import { PUBLIC_API_BASE_URL } from '$env/static/public';

const TRUSTED_PAYSO_ORIGINS = new Set([
	'https://3dprintingservice.3dai.co.th',
	'https://sitedev.3dai.co.th'
]);

const PAYSO_ATTRIBUTE_KEYS = new Set([
	'merchantid',
	'msecretkey',
	'prdrefno',
	'prddet',
	'prdtotal',
	'prdcc',
	'prdlang',
	'prdcustemail',
	'prdcusttel',
	'prdcustname',
	'merlogo',
	'mername',
	'paychannel'
]);

const PAYSO_RETURN_URL = 'https://3dai.co.th/3dprintingservice/dashboard?notipayment=true';
const PAYSO_WEBHOOK_URL = `${PUBLIC_API_BASE_URL.replace(/\/$/, '')}/api/webhooks/payment`;

type PaysoPayload = Record<string, unknown>;

function isPaysoPayload(value: unknown): value is PaysoPayload {
	return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function handlePaysoMessage(event: MessageEvent) {
	if (!TRUSTED_PAYSO_ORIGINS.has(event.origin)) {
		return;
	}

	const data = event.data as { type?: unknown; payload?: unknown } | null;
	if (!data || typeof data !== 'object' || data.type !== 'OPEN_PAYSOLUTIONS_FORM') {
		return;
	}

	if (!isPaysoPayload(data.payload)) {
		return;
	}

	const refno = data.payload.prdrefno;
	if (typeof refno !== 'string' || refno.trim() === '') {
		return;
	}

	const button = document.getElementById('pspayment');
	if (!(button instanceof HTMLButtonElement)) {
		return;
	}

	for (const [key, value] of Object.entries(data.payload)) {
		if (PAYSO_ATTRIBUTE_KEYS.has(key) && value != null) {
			button.setAttribute(key, String(value));
		}
	}

	button.setAttribute('prdpburl', PAYSO_WEBHOOK_URL);
	button.setAttribute('prdrturl', PAYSO_RETURN_URL);
	localStorage.setItem('payment_refno', refno);

	console.info('Opening PaySolutions form from trusted iframe', { refno });
	button.click();
}
